import { createSlice } from "@reduxjs/toolkit";

import { FetchAllElementsStatus } from "utils/trackAllElementsDone";
import { changeTextData } from "./textReducer";
import { changeDateData } from "./dateReducer";
import { setSignaturePathWithEncoddedImg } from "./signatureReducer";
import { changeEmailData } from "./emailReducer";
import { changePicklistData } from "./picklistReducer";

export const allFinalDataSlice = createSlice({
  name: "allFinalData",
  initialState: {
    totalNoOfFields: 0,
    completedNoOfFields: 0,
    listOfCompletedElements: [],
  },
  reducers: {
    setTotalNoOfFields: (state, action) => {
      const { allCoordinateData } = action.payload;
      state.totalNoOfFields = allCoordinateData.filter(
        (item) => item.isRequired
      ).length;
    },
    setCompletedNoOfFields: (state, action) => {
      const { completedNoOfFields } = action.payload;
      state.completedNoOfFields = completedNoOfFields;
    },
  },
  extraReducers: (builder) => {
    const updateProgress = (state, action) => {
      const { totalDoneElements } = FetchAllElementsStatus(action.payload);
      state.completedNoOfFields = totalDoneElements;
    };
    builder.addCase(changeTextData.type, updateProgress);
    builder.addCase(changeEmailData.type, updateProgress);
    builder.addCase(changeDateData.type, updateProgress);
    builder.addCase(setSignaturePathWithEncoddedImg.type, updateProgress);
    builder.addCase(changePicklistData.type, updateProgress);
  },
});

// Action creators are generated for each case reducer function
export const { setTotalNoOfFields, setCompletedNoOfFields } =
  allFinalDataSlice.actions;

export default allFinalDataSlice.reducer;
